import React, { useState, lazy, Suspense, useEffect } from "react";
import axios from "axios";
import "@fontsource/poppins";
import "./App.css";
import Navbar from './components/Navbar';
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import jsonData from "./components/ai-branding.json"; // Import the JSON file
//import EventMemories from "./components/PostEvent/EventMemories.js"
import MediaQuery from 'react-responsive';
import { CookieSetting } from "cookiesetting-component";
import { useHyperlink } from "./contexts/HyperlinkProvider.js";

const Body = lazy(() => import("./components/PostEvent/Body.js"));
const SocialMedia = lazy(() => import("./components/PostEvent/SocialMedia.js"));
const ThankYou = lazy(() => import("./components/PostEvent/ThankYou.js"));
const Footer = lazy(() => import("./components/FooterNew/index.js"));
const Video = lazy(() => import('./components/Video/Video.js'));
const Experience = lazy(() => import('./components/PostEvent/Experience.js'));
const EventMemories = lazy(() => import('./components/PostEvent/EventMemories.js'));
const EventMemoriesMobile = lazy(() => import('./components/PostEvent/EventMemoriesMobile.js'));

function App() {
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const imgCDNURL = process.env.REACT_APP_MEETMORGAN_CDN_URL;
  const appVersion = appversion.version;
  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [swmcLink, setSwmcLink] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 0);
      const swmcLink = await getHyperLink("websites", "swmc", 1);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West");
      setSwmcLink(swmcLink || "Sun West Mortgage Company, Inc.");
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);


  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };

  const [links, setLinks] = useState(null); // Set initial state as null

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
        console.log(response)
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <div className="bodyContainer">

      {/* <img src={small} className="flower img-fluid" 
                            alt="Flower" />
      <img src={small} className="flower1 img-fluid" 
                            alt="Flower" />
       <img src={small} className="flower2 img-fluid" 
                            alt="Flower" />
        <img src={imgCDNURL + "bluebg.webp"} className="bluebg img-fluid" 
                            alt="dots" />
       <img src={yellow} className="yellow img-fluid" 
                            alt="dots" />
               */}
      <Navbar />
      <Suspense fallback={<div />}>
        <Body links={links} angelAiLink={angelAiLink}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <Experience links={links} />
      </Suspense>
      <MediaQuery minWidth={992}>
        <Suspense fallback={<div />}>
          <EventMemories links={links} />
        </Suspense>
      </MediaQuery>
      {/* Renders the components of mobile and tablet view */}
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <EventMemoriesMobile links={links} />
        </Suspense>
      </MediaQuery>
      <Suspense fallback={<div />}>
        <SocialMedia />
      </Suspense>
      <Suspense fallback={<div />}>
        <ThankYou links={links} angelAiLink={angelAiLink}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer links={links} />
      </Suspense>
      <CookieSetting
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </div>
  );
}

export default App;
